import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { get, post } from '../_services/apiService';
import { API_URL } from '../_services/apiUrl';
import { toast } from 'react-toastify';
// import { saveWishProduct, deleteWishProductByLoginProductId } from '../_services'; 

const WishlistContext = createContext();

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const loginId = localStorage.getItem('loginId');
  const [wishlist, setWishlist] = useState([]);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWishlist = useCallback(async () => {
    if (!loginId) return;

    try {
      setLoading(true);
      const response = await get(API_URL.GetWishProductByLoginId + `?pLoginId=${loginId}`);
      if (response.isSuccess === 200) {
        setWishlist((prevData) => {
          if (JSON.stringify(prevData) !== JSON.stringify(response.data)) {
            return response.data || [];
          }
          return prevData;
        });
      } 
    } catch (error) {
      setError('Please try again later.');
    }
  }, [loginId]);

  useEffect(() => {
    if (loginId) {
      fetchWishlist();
    }
  }, [loginId, fetchWishlist]);

  const addToWishlist = async (formData) => {
    try { 
      const response = await post(API_URL.SaveWishProduct, formData);

      if (response.isSuccess === 200) {
        setWishlist((prev) => {
          if (Array.isArray(prev)) {
            return [...prev, response.data];
          }
          return [response.data]; 
        });
        fetchWishlist();
      } 
    } catch (error) {
      toast.error("Failed to this product added to your Wishlist!");
    }
  };

  const removeFromWishlist = async (item) => {

    try {
      const response = await get(API_URL.DeleteWishProductByLoginProductId + `?pProductId=${item.productId}&pLoginI=${loginId}`);

      if (response.isSuccess === 200) {
        // setWishlist((prev) => prev.filter((product) => product.productId !== item.productId));
        fetchWishlist();
      }
    } catch (error) {
      toast.error("Failed to this product delete to your Wishlist!");
    }
  };

  return (
    <WishlistContext.Provider value={{ wishlist, setWishlist, loading, addToWishlist, removeFromWishlist, fetchWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};
